import { round } from 'lodash';
import type { ISliderValue } from '../multi-select-options/multi-select-options';
import { isPendingBeneficiaryId } from './beneficiary-picker';

export type AllocationError =
  | 'missing'
  | 'duplicate'
  | 'pending'
  | 'zero'
  | 'total';

const PERCENTAGE_DECIMAL_PLACES = 2;

export const getAllocationTotal = (values: ISliderValue[]): number =>
  round(
    values.reduce((total, { percentage }) => total + Number(percentage), 0),
    PERCENTAGE_DECIMAL_PLACES
  );

// The most one person can be raised to without the total passing 100: their
// own share plus whatever is still unallocated. Lowering is never capped.
export const getPercentageCeiling = (
  values: ISliderValue[],
  id: string
): number => {
  const own = Number(values.find((value) => value.id === id)?.percentage ?? 0);
  return round(
    own + 100 - getAllocationTotal(values),
    PERCENTAGE_DECIMAL_PLACES
  );
};

export const getAllocationError = (
  values: ISliderValue[],
  required: boolean
): AllocationError | null => {
  if (values.length === 0) {
    return required ? 'missing' : null;
  }
  if (values.some(({ id }) => isPendingBeneficiaryId(id))) {
    return 'pending';
  }
  if (values.some(({ percentage }) => Number(percentage) === 0)) {
    return 'zero';
  }
  return getAllocationTotal(values) === 100 ? null : 'total';
};
